export const Colors = {
  bg: "#ffffff",
  borderColor: "#e5e5ea",
  hover: "#ebf5ff",
  gray1: "#FAFAFA",
  gray2: "#F5F5F5",
  gray3: "#EEEEEE",
  gray4: "#E5E5EA",
  gray5: "#BABABA",
  gray6: "#9E9E9E",
  disabled: "#9E9E9E",
  gray7: "#757575",
  gray8: "#616161",
  gray9: "#424242",
  gray10: "#212121",
  white: "#ffffff",
  black: "#000000",
  accent: "#0156f9",
  link: "#0156f9",
  error: "#e74c3c",
  warning: "#ff8800",
  success: "#44bd32",
  text: "#1f243c",
  subtitle: "#808182",
  softRed: "#ff6961",
};
